var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-progress',{attrs:{"percentage":_vm.percentage,"color":_vm.customColors,"stroke-width":18,"text-inside":true,"format":_vm.format}})
}
var staticRenderFns = []

export { render, staticRenderFns }